import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { LegalPageLayout } from "@/components/LegalPageLayout";

export const Route = createFileRoute("/about")({
  head: () => ({
    meta: [
      { title: "About Lumvio — Verified client portal for freelancers" },
      {
        name: "description",
        content:
          "Lumvio is the identity-verified client portal for freelancers: Payment Protection on every milestone, real-time client chat, invoices and payouts in one workspace.",
      },
      {
        name: "keywords",
        content:
          "about Lumvio, verified freelancer workspace, client portal for freelancers, freelance payment protection, identity-verified freelancers",
      },
      { property: "og:title", content: "About Lumvio — Verified client portal for freelancers" },
      {
        property: "og:description",
        content:
          "How Lumvio protects freelancers and clients with identity verification and Payment Protection on every milestone.",
      },
      { property: "og:url", content: "https://lumvio.co/about" },
    ],
    links: [
      { rel: "canonical", href: "https://lumvio.co/about" },
      { rel: "alternate", hrefLang: "en", href: "https://lumvio.co/about" },
      { rel: "alternate", hrefLang: "ar", href: "https://lumvio.co/about" },
      { rel: "alternate", hrefLang: "x-default", href: "https://lumvio.co/about" },
    ],

  }),
  component: AboutPage,
});

function renderMd(s: string) {
  const parts = s.split(/(\*\*[^*]+\*\*)/g);
  return parts.map((p, i) =>
    p.startsWith("**") && p.endsWith("**") ? (
      <strong key={i}>{p.slice(2, -2)}</strong>
    ) : (
      <span key={i}>{p}</span>
    ),
  );
}

function AboutPage() {
  const { t } = useTranslation();
  const diffList = t("aboutPage.diffList", { returnObjects: true }) as string[];
  return (
    <LegalPageLayout title={t("aboutPage.title")} updated={t("aboutPage.updated")}>
      <p>{t("aboutPage.intro")}</p>

      <h2>{t("aboutPage.missionHeading")}</h2>
      <p>{t("aboutPage.missionBody")}</p>

      <h2>{t("aboutPage.diffHeading")}</h2>
      <ul>
        {diffList.map((item, i) => (
          <li key={i}>{renderMd(item)}</li>
        ))}
      </ul>

      <h2>{t("aboutPage.contactHeading")}</h2>
      <p>
        {t("aboutPage.contactBody")}{" "}
        <a href="mailto:contact@lumvio.co">contact@lumvio.co</a>.
      </p>
    </LegalPageLayout>
  );
}
